"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSocialAccountApi = void 0;
const restclient_1 = require("nordic/restclient");
const ButtonRequestProps_1 = require("../../types/ButtonRequestProps");
const enums_1 = require("../../utils/enums");
const utils_1 = require("../../utils");
const getSocialApiURL = (scope) => {
    const url = new URL('social-account-api/public/social/google/account', 'https://api.mercadolibre.com');
    if (scope) {
        url.searchParams.set('scope', scope);
    }
    return url.href;
};
class AuthSocialAccountApi {
    static async initGoogleAccount(navigation, credential, scope) {
        try {
            const url = getSocialApiURL(scope);
            const headers = {
                [enums_1.Headers.X_SITE_ID]: navigation.site_id,
                [enums_1.Headers.X_PLATFORM_ID]: navigation.platform_id,
                [enums_1.Headers.X_CLIENT_TYPE]: navigation.client_type,
                [enums_1.Headers.X_SOURCE]: navigation.source,
                [enums_1.Headers.X_CONTEXTUAL]: navigation.contextual,
                [enums_1.Headers.CONTENT_TYPE]: 'application/json',
                [enums_1.Headers.X_USER_AGENT]: window.navigator.userAgent,
            };
            const response = await this.restclient.post(url, {
                headers,
                data: {
                    google_jwt: credential.credential,
                    data: {
                        query_params: {
                            redirect_url: navigation.go,
                            challenge_type: navigation.challenge_type,
                            selected_method: (0, utils_1.isGoogleButton)(credential.select_by)
                                ? ButtonRequestProps_1.AuthCapabilities.GOOGLE_BUTTON
                                : ButtonRequestProps_1.AuthCapabilities.GOOGLE_ONE_TAP,
                        },
                    },
                },
            });
            return response.data;
        }
        catch (error) {
            return Promise.reject(Error(error));
        }
    }
}
exports.AuthSocialAccountApi = AuthSocialAccountApi;
AuthSocialAccountApi.restclient = (0, restclient_1.RestClient)();
